export const openEmailDraft = (emailTo: string, subject: string = '', emailBody: string = '') => {
  window.open(
    getEmailDraftHref(emailTo, subject, emailBody)
  );
};

export const getEmailDraftHref = (emailTo: string, subject: string = '', emailBody: string = '') => {
  return `mailto:${emailTo}?subject=${subject}&body=${emailBody}`;
};
